import { render, staticRenderFns } from "./date-time-picker-valueFormat-editor.vue?vue&type=template&id=0c8a3bc0&scoped=true"
import script from "./date-time-picker-valueFormat-editor.vue?vue&type=script&lang=js"
export * from "./date-time-picker-valueFormat-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8a3bc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8a3bc0')) {
      api.createRecord('0c8a3bc0', component.options)
    } else {
      api.reload('0c8a3bc0', component.options)
    }
    module.hot.accept("./date-time-picker-valueFormat-editor.vue?vue&type=template&id=0c8a3bc0&scoped=true", function () {
      api.rerender('0c8a3bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-date-time-picker/date-time-picker-valueFormat-editor.vue"
export default component.exports